import clamp from "lodash/clamp";
import last from "lodash/last";
import type { Day } from "PFApp/booking/parts/overview/booking_module_calendar/booking_calendar/booking_calendar_store";

const getDayIndex = (x: number, days: Day[]): number => days.findIndex(({ left }) => left > x) - 1;

type GetNumberOfDraggedDays = {
  currentMouseX: number;
  originClickX: number;
  rowStartX: number;
  days: Day[];
};

export const getNumberOfDraggedDays = ({
  currentMouseX,
  originClickX,
  rowStartX,
  days
}: GetNumberOfDraggedDays): number => {
  const mouseX = currentMouseX - rowStartX;
  const { left: lastDayLeft, width: lastDayWidth } = last(days)!;
  const draggedDayIndex = getDayIndex(clamp(mouseX, 0, lastDayLeft + lastDayWidth), days);

  const outOfCalendarDayIndex = mouseX < originClickX ? 0 : days.length - 1;
  const limitedDraggedDayIndex = draggedDayIndex < 0 ? outOfCalendarDayIndex : draggedDayIndex;

  return limitedDraggedDayIndex - getDayIndex(originClickX, days);
};
